import { Injectable } from '@angular/core';
import { Observer, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  public isAvailable: boolean = !!navigator.geolocation;
  public errorCode!: number;

  getCurrentPosition(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          observer.next(position);
          observer.complete();
        },
        (error: any) => {
          this.errorCode = error.code;
          observer.error(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 10000,
        }
      );
    });
  }
}
